import '../Register/Register.scss';
import React from 'react';
import { useFormik } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const UpdatePass = () => {

    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            admin_moNo: "",
            admin_pass: "",
            admin_conf_pass: ""
        },


        //second parameter
        validate: (values) => {
            const errors = {}   //create blank array

            if (!values.admin_moNo) {
                errors.admin_moNo = "Please Enter valid mo_no"
            }
            if (!values.admin_pass) {
                errors.admin_pass = "Please Enter Password";
            } else if (values.admin_pass.length < 8) {
                errors.admin_pass = "Password should be at least 8 characters long";
            } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/.test(values.admin_pass)) {
                errors.admin_pass = "Password should contain at least one uppercase letter, one lowercase letter, one digit, and one special character (!@#$%^&*)";
            }

            if (!values.admin_conf_pass) {
                errors.admin_conf_pass = "Please confirm your password";
            } else if (values.admin_conf_pass !== values.admin_pass) {
                errors.admin_conf_pass = "Passwords do not match";
            }


            return errors   // jo arror condition sachi no pade to aayathi return thai ne bydefualt blank mokli deshe
        },
        onSubmit: async (value) => {
            var forgotEmail = localStorage.getItem('forgotEmail')
            console.log(forgotEmail);

            axios.post('http://localhost:3010/admin/updatePass', {

                withCredentials: true,
                data: value,
                forgotEmail: forgotEmail

            })
                .then(function (res) {
                    console.log(res, "create data")
                    navigate("/adminLogin");
                })
                .catch(function (res) {
                    console.log(res)
                    toast.error("Envalid Credential")

                })
        }
    })


    return (
        <>
            <div className="banner  mt-5">
                <div className="row signin m-0">
                    <div className="text-white mt-5 ps-5">
                        <a href='/admin/home' className='text-white text-decoration-none'><h6 className=''>Forgot &nbsp; / &nbsp; Password </h6></a>
                        <h3 className="text-white">admin Forgot Password</h3>
                    </div>
                </div>

                <div className="container register-form mb-5">
                    <div className="row justify-content-center">
                        <div className="box row p-3 mt-5 border border-secondary-subtle rounded">
                            <div className="d-flex justify-content-center">
                                <h2>Forgot Here</h2>
                            </div>

                            <form method="post" onSubmit={formik.handleSubmit}>
                                <div className="row mt-4 my-4">
                                    <div className="col-md-12 col-12 mt-3">
                                        <label>Email or Mobile Number </label>
                                        <input
                                            type="number"
                                            name="admin_moNo"
                                            value={formik.values.admin_moNo}
                                            onChange={formik.handleChange}
                                            className="w-100 form-control shadow-none mt-2"
                                            placeholder="Mobile No"
                                        />
                                        {formik.touched.admin_moNo && formik.errors.admin_moNo ? (
                                            <p className="text-danger">{formik.errors.admin_moNo}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-12 col-12 mt-3">
                                        <label>Password </label>
                                        <input
                                            type="password"
                                            name="admin_pass"
                                            value={formik.values.admin_pass}
                                            onChange={formik.handleChange}
                                            className="w-100 form-control shadow-none mt-2"
                                            placeholder="password"
                                        />
                                        {formik.touched.admin_pass && formik.errors.admin_pass ? (
                                            <p className="text-danger">{formik.errors.admin_pass}</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-12 col-12 mt-3">
                                        <label>Confirm Password </label>
                                        <input
                                            type="password"
                                            name="admin_conf_pass"
                                            value={formik.values.admin_conf_pass}
                                            onChange={formik.handleChange}
                                            className="w-100 form-control shadow-none mt-2"
                                            placeholder="confirm password"
                                        />
                                        {formik.touched.admin_conf_pass && formik.errors.admin_conf_pass ? (
                                            <p className="text-danger">{formik.errors.admin_conf_pass}</p>
                                        ) : null}
                                    </div>





                                    <div className="d-flex justify-content-center">
                                        <button
                                            type="submit"
                                            className="submit-btn w-25 mt-4 text-white rounded py-2"
                                        >
                                            Submit
                                        </button>
                                    </div>

                                    <div className="divider d-flex align-items-center my-4 py-0">
                                        <span className='fs-6 px-4'>Or Continue With</span>
                                    </div>


                                    <div className="signup-link d-inline-flex justify-content-center mt-3">
                                        <p>Don't have an account? <Link to={'/adminLogin'} className='font-weight-bold text-black text-decoration-none'>Sign in</Link></p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UpdatePass;
